import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs`, resetting the timer on every change.
 *
 * Used to keep a search box responsive while the query it drives hits the
 * server (see the DocuSeal submissions search in AdminDashboard /
 * TeamMemberDashboard, which pages the live DocuSeal API - one request per
 * keystroke there would be a real cost, not just a wasted render).
 */
export function useDebouncedValue<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
